<template>
    <div>
        <TabView class="custom-tabview">
            <TabPanel header="Documentos" class="custom-tabpanel">
                <docs :docs="FilesDocumentation" />
            </TabPanel>
            <TabPanel header="Comunicados" class="custom-tabpanel">
                <communication :files="FilesCommunication" />
            </TabPanel>
        </TabView>
    </div>
</template>

<script setup>
import axios from 'axios';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import docs from './components/Docs.vue';
import communication from './components/Communication.vue';
import { onBeforeMount, computed, ref } from 'vue';
import { useStore } from "vuex"

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);

const FilesDocumentation = ref(null);
const FilesCommunication = ref(null);
const loading = ref(true);

onBeforeMount(() => {
    getAllDocuments()
});

const getAllDocuments = async () => {
    try {
        const response = await axios.get(`/clients/contract/${contractData.value.contrato_id}/documents`);

        FilesDocumentation.value = response.data.filter(doc => doc.document_category_id === 1);
        FilesCommunication.value = response.data.filter(doc => doc.document_category_id === 10);
    } catch (error) {
        console.error('Erro na requisição:', error);
        throw error;
    } finally {
        loading.value = false
    }
}

</script>

<style>
.custom-tabview .p-tabview-nav {
    border-radius: 13px;
    flex: 1 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center;
}

.custom-tabview .p-tabview-panels {
    border-radius: 13px;
}

.custom-tabpanel {
    border-radius: 13px;
}
</style>
